var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c(
        "van-pull-refresh",
        {
          on: { refresh: _vm.onRefresh },
          model: {
            value: _vm.refreshing,
            callback: function ($$v) {
              _vm.refreshing = $$v
            },
            expression: "refreshing",
          },
        },
        [
          _c(
            "van-list",
            {
              staticClass: "p-l-20 p-r-20 p-b-20",
              attrs: {
                error: _vm.error,
                finished: _vm.finished,
                "immediate-check": false,
                "finished-text": "没有更多了",
              },
              on: {
                "update:error": function ($event) {
                  _vm.error = $event
                },
                load: _vm.getList,
              },
              model: {
                value: _vm.loading,
                callback: function ($$v) {
                  _vm.loading = $$v
                },
                expression: "loading",
              },
            },
            _vm._l(_vm.list, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "bg-FF p-20 m-t-20" },
                [
                  _c("div", { staticClass: "flex col-center row-between" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex-1 ellipsis-1 font-30 cor-3E3A39 font-weight-500 m-l-10",
                      },
                      [_vm._v(" " + _vm._s(item.reportName) + " ")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "font-26 cor-F8B91A p-l-20 p-r-10 p-b-6 p-t-6",
                        on: {
                          click: function ($event) {
                            return _vm.viewFile_1(item)
                          },
                        },
                      },
                      [_vm._v("预览")]
                    ),
                  ]),
                ]
              )
            }),
            0
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }